import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import Button from '../components/Button';

const ResultsPage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <>
      <h2 className="font-title text-3xl font-semibold">{t('home.title')}</h2>
      <section className="mt-8">
        <p className="my-6 font-title text-xl font-semibold">
          {t('home.subtitle')}
        </p>
        <p className="my-6">{t('home.description1')}</p>
        <p className="my-6">{t('home.description2')}</p>
        <p className="my-6 font-title text-xl font-semibold">{t('home.cta')}</p>
        <div className="flex flex-col gap-4 text-sm font-light text-gray2 sm:flex-row">
          <div>
            <Button onClick={() => navigate('/test')} className="mt-6">
              {t('home.startButton')}
            </Button>
            <p className="mt-3 pr-4">
              <strong>{t('home.info')}</strong>.
            </p>
          </div>
        </div>
      </section>
    </>
  );
};

export default ResultsPage;
